// extracted by mini-css-extract-plugin
module.exports = {"lead_form__button":"lead_form__button","lead_form__button_delivery":"lead_form__button_delivery"};